export default function LdaDeliverableRow({ node, depth, renderDeliverable }) {
  return renderDeliverable(node.metadata.line, { depth, revision: node.metadata.revision });
}
